/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGlobalSearch, useProcess } from "@/global-data";
import { useDeletePopup } from "@/global-data/use-delete-popup";
import { useDebouncedValue } from "@/hooks/use-debounced-value";
import { useToast } from "@/hooks/use-toast";
import { getFileUrl } from "@/lib/get-file-url";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import {
  customer_mapping,
  documentsUpload,
  retailers,
  snc_customers,
  snc_erp_uom,
} from "@/services/global.services";
import { useEffect, useMemo, useState } from "react";

export const useMutations = () => {
  const API_SERVICE = customer_mapping;
  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const { setProcess } = useProcess();
  const [skeltonLoading, setSkeltonLoading] = useState(true);
  const [listData, setListData] = useState([]);
  // const [retailerList, setRetailerList] = useState([]);
  const [companyData, _setCompanyData] = useState([]);
  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [activeRecordData, setActiveRecordData] = useState<any>(undefined);
  const [tableColumn, setTableColumn] = useState([]);
  const [retailerDropdownList, setRetailerDropdownList] = useState([]);
  const [sncErpUomList, setSncErpUomList] = useState<any>([]);

  const { setSearchProgress, search } = useGlobalSearch();
  const { toast } = useToast();
  const [searchDebounced] = useDebouncedValue(search, 200);
  const [deleteId, setDeleteId] = useState(undefined);
  const [filter, setFilter] = useState({});

  const [sortBy, setSortBy] = useState("cts");
  const [orderBy, setOrderBy] = useState(false);

  const { onDelete, status, identity, clearDelete } = useDeletePopup();
  const [sncCustomerList, setSncCustomerList] = useState([]);

  const [paginationData, setPaginationData] = useState({
    page: 1,
    perPage: 10,
    totalItem: 1,
  });

  const [errorMessage, setErrorMessage] = useState<any>({
    title: "",
    message: "",
    open: false,
  });

  const closeErrorMessage = () => {
    setErrorMessage({
      title: "",
      message: "",
      open: false,
    });
  };

  //On Load Component
  useEffect(() => {
    (async () => {
      await Promise.all([
        loadingList({ searchText: "" }),
        loadingRetailerDropdownList(),
        loadingSncErpUom(),
        loadSNCustomer(),
      ]);
      // await loadingList({ searchText: "" });
      // await loadingRetailerDropdownList();
      // await loadingSncErpUom();
      // await loadSNCustomer();
      await wait(1000);
      setSkeltonLoading(false);
      setProcess(false);
    })();
    return () => {
      closeErrorMessage();
    };
  }, []);

  const loadingRetailerDropdownList = async () => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message /* error, message, statusCode */ } =
      await apiServices<any>(retailers.get, "post", payload);

    if (data) {
      setRetailerDropdownList(data.result.metadata?.[retailers.key]);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  //handle delete
  useEffect(() => {
    if (status === "cancel") {
      setDeleteId(undefined);
      clearDelete();
    }
    if (status === "delete" && identity === "user") {
      (async () => {
        setProcess(true);
        const deleteResponse = await deleteRecord();
        if (deleteResponse.data) {
          await loadingList({});
          toast({
            title: "Success",
            variant: "success",
            description:
              deleteResponse?.data.result.metadata.message ??
              deleteResponse?.data?.status?.msg ??
              deleteResponse?.data?.status?.message,
          });
        }
        clearDelete();
        setDeleteId(undefined);
        setActiveRecordData(undefined);
        setProcess(false);
      })();
    }
  }, [status]);

  const deleteRecord = async () => {
    const payload = {
      data: {
        uom_map_id: deleteId,
        company_id: company_id,
      },
      company_id: company_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_SERVICE.delete,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    return { data, error };
  };

  //Handle Search
  useEffect(() => {
    if (skeltonLoading === false) {
      (async () => {
        setSearchProgress(true);
        await loadingList({});
        setSearchProgress(false);
      })();
    }
  }, [searchDebounced]);

  const onFormOpenChange = (prop: boolean) => {
    setFormPopupOpen(prop);
  };

  const onPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, page: prop }));
    setProcess(true);
    await loadingList({ page: prop });
    setProcess(false);
  };
  const onPerPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
    setProcess(true);
    await loadingList({ perPage: prop, page: 1 });
    setProcess(false);
  };

  const permission: any = [];
  const onAction = async ({ action, data }: any) => {
    if (action === "edit") {
      setActiveRecordData(data);
      onFormOpenChange(true);
    }
    if (action === "delete") {
      setActiveRecordData(data);
      setDeleteId(data.uom_map_id);
      onDelete({
        description:
          "This action cannot be undone. This will permanently delete the record and remove its data from our system.",
        id: data.user_id,
        identity: "user",
        popupStatus: true,
        title: "Are you sure you want to delete this UOM mapping?",
      });
      await loadingList({});
    }
  };

  const sortingHandler = async (prop: string) => {
    const tempSortBy = prop;
    const tempOrderBy = sortBy == prop ? !orderBy : true;
    console.log({ tempSortBy, tempOrderBy });
    setProcess(true);
    setSortBy(tempSortBy);
    setOrderBy(tempOrderBy);
    await loadingList({
      sortByProp: tempSortBy,
      orderByProp: tempOrderBy,
    });
    setProcess(false);
  };

  useEffect(() => {
    if (formPopupOpen === false) {
      setActiveRecordData(undefined);
      closeErrorMessage();
    }
  }, [formPopupOpen]);

  const loadingList = async ({
    perPage,
    page,
    filterReset,
    makeFilter,
    searchText,
    orderByProp,
    sortByProp,
  }: {
    perPage?: number;
    page?: number;
    filterReset?: boolean;
    makeFilter?: boolean;
    searchText?: string;
    orderByProp?: any;
    sortByProp?: any;
  }) => {
    let apiFilter = {};

    if (!filterReset) {
      apiFilter = filter;
    }

    let page_no = page || paginationData.page;

    if (makeFilter) {
      page_no = 1;
    }

    const tempSortBy = sortByProp ?? sortBy;
    const tempOrderBy = orderByProp ?? orderBy;

    const payload = {
      data: {
        // username: userData?.username,
        filter_by: {
          ...apiFilter,
          search_text: searchText ?? searchDebounced,
          exact_match: false,
          pagination: {
            page_no: page_no,
            no_of_recs: perPage || paginationData.perPage,
            sort_by: tempSortBy,
            order_by: tempOrderBy,
          },
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message /* error, message, statusCode */ } =
      await apiServices<any>(API_SERVICE.get, "post", payload);

    if (data) {
      const listData = data.result.metadata.uom_mapping;
      setListData(listData);
      // const retailerIdList = listData?.map((item: any) => item.retailer_id);
      // await loadingRetailer({ retailer_id: retailerIdList || [] });
      setPaginationData((prev) => ({
        ...prev,
        totalItem: data?.result?.metadata?.total_records || 1,
      }));
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    return { data, error };
  };
  // const loadingRetailer = async (retailerProp: any) => {
  //   // const userData: any = getUserInfo();
  //   const payload = {
  //     data: {
  //       filter_by: {
  //         ...retailerProp,
  //         search_text: "",
  //         exact_match: false,
  //       },
  //     },
  //     company_id: company_id,
  //     user_id: user_id,
  //   };
  //   const { data, error, message /* error, message, statusCode */ } =
  //     await apiServices<any>(retailers.get, "post", payload);

  //   if (data) {
  //     setRetailerList(data.result.metadata?.[retailers.key]);
  //   }

  //   if (error) {
  //     toast({
  //       title: "Error",
  //       variant: "destructive",
  //       description: error.status?.message || message,
  //     });
  //   }

  //   return { data, error };
  // };

  const onFormSubmit = async (prop: any): Promise<any> => {
    closeErrorMessage();
    let formData = {};

    if (activeRecordData) {
      formData = {
        customer_branches: prop.customer_branches,
        decimal_places:
          prop?.decimal_places === "" ||
          prop?.decimal_places === null ||
          prop?.decimal_places === undefined
            ? null
            : +prop.decimal_places,
        uom: prop.uom,
        erp_uom: prop.erp_uom,
        sku_code: prop.sku_code,
        conversion_rate: prop.conversion_rate,
        po_uom_qty: prop.po_uom_qty ?? 1,
        uom_map_id: activeRecordData.uom_map_id,
      };
    } else {
      formData = {
        customer_branches: prop.customer_branches,
        uom: prop.uom,
        decimal_places:
          prop?.decimal_places === "" ||
          prop?.decimal_places === null ||
          prop?.decimal_places === undefined
            ? null
            : +prop.decimal_places,
        erp_uom: prop.erp_uom,
        sku_code: prop.sku_code,
        conversion_rate: prop.conversion_rate,
        po_uom_qty: prop.po_uom_qty ?? 1,
      };
    }

    const payload = {
      data: formData,
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_SERVICE.post,
      "post",
      payload,
    );

    if (data) {
      await loadingList({});
      toast({
        title: "Success",
        variant: "success",
        description:
          data.result.metadata.message ??
          data?.status?.msg ??
          data?.status?.message,
      });
    }

    if (error) {
      // toast({
      //   title: "Error",
      //   variant: "destructive",
      //   description: error.status?.message || message,
      // });
      setErrorMessage({
        title: "Error",
        description: error.status?.message || message,
        open: true,
      });
    }

    setProcess(false);

    return { data, error };
  };

  const filterRequest = async () => {
    setProcess(true);
    await loadingList({ makeFilter: true });
    setProcess(false);
  };
  const clearFilter = async () => {
    setFilter({});
    setProcess(true);
    await loadingList({ filterReset: true });
    setProcess(false);
  };

  const exportDocument = async () => {
    setProcess(true);
    const payload = {
      data: {},
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message /* error, message, statusCode */ } =
      await apiServices<any>(API_SERVICE.export, "post", payload);

    console.log({ data, error, message });
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    if (data) {
      const listData = data.result.metadata.export_path;
      const url = await getFileUrl(listData);

      console.log({ url });
      downloadImage(url);
    }
    setProcess(false);
  };

  function downloadImage(url: string) {
    // Create an anchor element
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "downloaded-document";

    // Append the anchor to the document body
    document.body.appendChild(anchor);

    // Programmatically click the anchor to trigger the download
    anchor.click();

    // Remove the anchor from the document
    document.body.removeChild(anchor);
  }

  const onRunDocument = async (prop: any): Promise<any> => {
    setProcess(true);

    const payload = {
      data: { file_path: prop },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message /* statusCode */ } = await apiServices<any>(
      API_SERVICE.import,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const importDocument = async (prop: any) => {
    if (!prop) return;
    setProcess(true);
    const payload = new FormData();

    payload.append("files", prop);

    const { data, error, message /* statusCode */ } = await apiServices<any>(
      documentsUpload.post + "/" + company_id,
      "post",
      payload,
    );

    if (data) {
      const runDocument = await onRunDocument(data.metadata.file_path);

      await loadingList({});
      toast({
        title: "Success",
        variant: "success",
        description: runDocument?.data?.result?.metadata?.message,
      });
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
  };

  const loadingSncErpUom = async () => {
    const payload = {
      data: {
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      snc_erp_uom.get,
      "post",
      payload,
    );

    if (data) {
      console.log(data.result.metadata);
      setSncErpUomList(data.result.metadata[snc_erp_uom.key]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const loadSNCustomer = async () => {
    setProcess(true);
    const payload = {
      data: {
        // pull_from_db: true,
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      snc_customers.get,
      "post",
      payload,
    );

    if (data) {
      setSncCustomerList(data.result.metadata[snc_customers.key]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);

    return { data, error };
  };

  return {
    skeltonLoading,
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    activeRecordData,
    onFormSubmit,
    onFormOpenChange,
    formPopupOpen,
    tableColumn,
    setTableColumn,
    companyData,
    // retailerList,
    filter,
    setFilter,
    filterRequest,
    clearFilter,
    retailerDropdownList,
    errorMessage,
    closeErrorMessage,
    exportDocument,
    importDocument,
    sncErpUomList,
    sortingHandler,
    sortBy,
    orderBy,
    loadSNCustomer,
    sncCustomerList,
  };
};
